// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'

const C = {
  bg: '#F2EDE4', border: '#DDD4C6',
  amber: '#B8721F', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
}
const f = 'Georgia, serif'

function formatDate(dateStr) {
  if (!dateStr) return ''
  try { return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }
  catch { return dateStr }
}

// auto_order = DIY with automatic parts — show both badges
const typeBadges = {
  diy:        [{ label: 'DIY',        bg: '#F2EDE4', color: '#9A7B68' }],
  contractor: [{ label: 'Contractor', bg: '#EBF5EF', color: '#2E6B4A' }],
  auto_order: [
    { label: 'DIY',   bg: '#F2EDE4', color: '#9A7B68' },
    { label: 'Parts', bg: '#FBF3E8', color: '#B8721F' },
  ],
}

export default function MaintenanceTaskTile({
  task,
  nextDue,
  status,
  isCompleted,
  lastCompleted,
  applianceName,
  showApplianceName,
  selfManaged,
  onCheck,
  onOpen,
  onOrderNow,
  onAddToJobs,
  isLast,
}) {
  const [hovered, setHovered] = useState(false)
  const badges = typeBadges[task.type] || typeBadges.diy
  const dueDateColor = status === 'overdue' ? C.danger : status === 'soon' ? C.amber : C.success

  return (
    <div
      style={{
        display: 'flex', alignItems: 'flex-start', gap: '12px',
        padding: '11px 0',
        borderBottom: isLast ? 'none' : `1px solid ${C.border}`,
        background: hovered && !selfManaged ? '#FAF7F2' : 'transparent',
        transition: 'background 0.15s',
        cursor: selfManaged ? 'default' : 'pointer',
        opacity: isCompleted ? 0.85 : 1,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => !selfManaged && onOpen && onOpen()}
    >
      {/* Circular checkbox */}
      <div
        onClick={(e) => { e.stopPropagation(); if (!selfManaged && onCheck) onCheck() }}
        style={{
          flexShrink: 0, width: '22px', height: '22px', borderRadius: '50%',
          border: `2px solid ${isCompleted ? C.success : C.border}`,
          background: isCompleted ? C.success : 'transparent',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: selfManaged ? 'default' : 'pointer', marginTop: '1px',
          transition: 'all 0.15s',
        }}
        title={selfManaged ? undefined : isCompleted ? 'Mark as not done' : 'Mark as done'}
      >
        {isCompleted && (
          <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
            <path d="M1 4.5l3 3L10 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>

      {/* Body */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '14px', fontWeight: '600', fontFamily: f,
          color: isCompleted ? C.success : C.brown,
          textDecoration: isCompleted ? 'line-through' : 'none',
          marginBottom: '2px',
        }}>
          {task.task}
        </div>

        {selfManaged ? (
          <div style={{ fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif' }}>
            Self-managed — no tracking needed
          </div>
        ) : (
          <>
            {/* Appliance name (if shown) + interval */}
            <div style={{ fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginBottom: '2px' }}>
              {showApplianceName ? `${applianceName} · ` : ''}{task.interval}
            </div>

            {/* Last completed — always shown */}
            <div style={{ fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginBottom: '2px' }}>
              {lastCompleted ? `Last done ${formatDate(lastCompleted)}` : 'Never completed'}
            </div>

            {/* Next due — always shown when known, color coded */}
            {nextDue && (
              <div style={{
                fontSize: '11px', fontFamily: 'Calibri, sans-serif',
                color: dueDateColor,
                fontWeight: status === 'overdue' || status === 'soon' ? '700' : '400',
              }}>
                {status === 'overdue'
                  ? `⚠ Overdue — due ${formatDate(nextDue)}`
                  : status === 'soon'
                    ? `⏰ Due ${formatDate(nextDue)}`
                    : `✓ Due ${formatDate(nextDue)}`}
              </div>
            )}

            {/* Part cost + Order Now */}
            {task.type === 'auto_order' && !isCompleted && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px', flexWrap: 'wrap' }}>
                {task.partCost && (
                  <div style={{ fontSize: '10px', color: C.success, fontFamily: 'Calibri, sans-serif', fontWeight: '600' }}>
                    ~{task.partCost} in parts
                  </div>
                )}
                {onOrderNow && (
                  <button
                    onClick={(e) => { e.stopPropagation(); onOrderNow() }}
                    style={{
                      background: 'transparent',
                      border: `1px solid ${C.amber}`,
                      borderRadius: '6px',
                      padding: '2px 10px',
                      fontSize: '10px',
                      color: C.amber,
                      cursor: 'pointer',
                      fontFamily: 'Calibri, sans-serif',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                      letterSpacing: '0.3px',
                    }}
                  >
                    Order Parts →
                  </button>
                )}
              </div>
            )}
            {/* Add to Jobs — contractor tasks */}
            {task.type === 'contractor' && onAddToJobs && (
              <button
                onClick={(e) => { e.stopPropagation(); onAddToJobs() }}
                style={{
                  background: 'transparent',
                  border: `1px solid ${C.amber}`,
                  borderRadius: '6px',
                  padding: '2px 10px',
                  fontSize: '10px',
                  color: C.amber,
                  cursor: 'pointer',
                  fontFamily: 'Calibri, sans-serif',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  marginTop: '4px',
                  display: 'inline-block',
                }}
              >
                + Add to Jobs
              </button>
            )}
          </>
        )}
      </div>

      {/* Category badges — stacked for auto_order. Parts badge becomes clickable when onOrderNow is provided. */}
      {!selfManaged && (
        <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '4px', alignSelf: 'flex-start', marginTop: '2px' }}>
          {badges.map((b, i) => {
            const isClickableParts = b.label === 'Parts' && !!onOrderNow && !isCompleted
            const baseStyle = {
              fontSize: '10px', fontFamily: 'Calibri, sans-serif',
              background: b.bg, color: b.color,
              border: `1px solid ${b.color}44`,
              borderRadius: '20px', padding: '3px 10px',
              fontWeight: '600', whiteSpace: 'nowrap', textAlign: 'center',
            }
            if (isClickableParts) {
              return (
                <button
                  key={i}
                  onClick={(e) => { e.stopPropagation(); onOrderNow() }}
                  title="Order parts on Amazon"
                  style={{ ...baseStyle, cursor: 'pointer' }}
                >
                  {b.label}
                </button>
              )
            }
            return (
              <div key={i} style={baseStyle}>
                {b.label}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
